module.exports = __webpack_public_path__ + "static/media/tenant.9a00c5a4.svg";